import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import { Box, Paper, Stack, Typography, alpha } from '@mui/material'

export default function OptionCard({ option, index, selected, onClick, disabled, multi }) {
    return (
        <Paper
            component="button"
            type="button"
            variant="outlined"
            onClick={onClick}
            disabled={disabled}
            sx={{
                width: '100%',
                height: '100%',
                cursor: disabled ? 'default' : 'pointer',
                textAlign: 'left',
                borderColor: disabled ? 'action.disabledBackground' : selected ? 'primary.main' : 'divider',
                bgcolor: (theme) =>
                    disabled
                        ? theme.palette.action.disabledBackground
                        : selected
                            ? alpha(theme.palette.primary.main, 0.08)
                            : theme.palette.background.paper,
                color: disabled ? 'text.disabled' : 'text.primary',
                opacity: disabled ? 0.72 : 1,
                p: 2,
                transition: 'border-color 160ms ease, background 160ms ease',
                display: 'flex',
                '&:hover': disabled
                    ? undefined
                    : {
                        borderColor: 'primary.main',
                    },
            }}
        >
            <Stack direction="row" alignItems="center" spacing={1.5} width="100%">
                <Box
                    sx={{
                        minWidth: 30,
                        minHeight: 30,
                        width: 30,
                        height: 30,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '1px solid',
                        borderColor: disabled ? 'action.disabled' : selected ? 'primary.main' : 'divider',
                        borderRadius: '6px',
                        color: disabled ? 'text.disabled' : selected ? 'primary.main' : 'text.secondary',
                        fontWeight: 700,
                    }}
                >
                    {index + 1}
                </Box>
                <Box flexGrow={1}>
                    <Typography variant="subtitle1" color={disabled ? 'text.disabled' : 'text.primary'}>
                        {option.label}
                    </Typography>
                    {option.description ? (
                        <Typography variant="body2" color={disabled ? 'text.disabled' : 'text.secondary'} mt={0.5}>
                            {option.description}
                        </Typography>
                    ) : null}
                </Box>
                {selected ? <CheckCircleIcon color="primary" /> : multi ? <RadioButtonUncheckedIcon color="disabled" /> : null}
            </Stack>
        </Paper>
    )
}
